var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6151_4926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H1C0.447715 0 0 0.447715 0 1V19.25C0 19.8023 0.447715 20.25 1 20.25H31C31.5523 20.25 32 19.8023 32 19.25V1C32 0.447715 31.5523 0 31 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6151_4926)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6151_4926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H1C0.447715 0 0 0.447715 0 1V19.25C0 19.8023 0.447715 20.25 1 20.25H31C31.5523 20.25 32 19.8023 32 19.25V1C32 0.447715 31.5523 0 31 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6151_4926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2L0.03 0L32 0.04L31.97 20.25L0 20.21V20.2Z",
    fill: "url(#paint0_linear_6151_4926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.008 3.38137L21.002 7.6743C21.0017 7.86955 21.1823 8.02808 21.4053 8.0284L28.5976 8.03844C28.8206 8.03875 29.0017 7.88072 29.002 7.68547L29.0079 3.39254C29.0082 3.19729 28.8276 3.03875 28.6046 3.03844L21.4123 3.0284C21.1893 3.02809 21.0082 3.18612 21.008 3.38137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0H0V20.25H1V0Z",
    fill: "#393CDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 10,
    height: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 20,
    height: 1,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6151_4926",
    x1: 1,
    y1: 17.5,
    x2: 32,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0395E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#3438DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677885,
    stopColor: "#9181B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostepay);
export default __webpack_public_path__ + "static/media/postepay.3b37ef3b3c3b1eb52d834aed146dfaf4.svg";
export { ForwardRef as ReactComponent };